import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Analytics from "./components/Analytics";
import HomePage from "./pages/HomePage";
import CoursesPage from "./pages/CoursesPage";
import CourseDetailPage from "./pages/CourseDetailPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicShell({ children }) {
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Analytics />
            <Routes>
              <Route path="/" element={<PublicShell><HomePage /></PublicShell>} />
              <Route path="/courses" element={<PublicShell><CoursesPage /></PublicShell>} />
              <Route path="/courses/:slug" element={<PublicShell><CourseDetailPage /></PublicShell>} />
              <Route path="/about" element={<PublicShell><AboutPage /></PublicShell>} />
              <Route path="/contact" element={<PublicShell><ContactPage /></PublicShell>} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<PublicShell><AdminDashboardPage /></PublicShell>} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
        </SettingsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
